import { useEffect } from "react";
import ModalComponent from "../../components/modals";
import LaddaButton from "../../components/buttons/laddaButton";
import FormTextField from "../../components/textField/formTextField";
import FormRadioButton from "../../components/formRadioButton";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import "./styles.css";

const MAX_COMMENT_LENGTH = 2000;

const validationSchema = yup.object().shape({
  comment: yup
    .string()
    .max(MAX_COMMENT_LENGTH, `Máximo ${MAX_COMMENT_LENGTH} caracteres`),
  needs_leader_review: yup.string().oneOf(["0", "1"])
});

const CompleteTaskModal = ({ open, handleClose, task, onConfirm }) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    setError,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { comment: "", needs_leader_review: "0" }
  });

  useEffect(() => {
    if (!open) return;
    setValue("comment", "");
    setValue("needs_leader_review", "0");
  }, [open, setValue]);

  const handleCloseModal = () => {
    reset();
    handleClose();
  };

  const onSubmit = (formData) => {
    const comment = formData.comment?.trim() || "";
    const classification = (task?.classification || "").toUpperCase();

    if (!comment && ["A", "B", "C"].includes(classification)) {
      setError("comment", {
        type: "manual",
        message:
          "Para tareas de clasificación A, B o C el comentario es obligatorio."
      });
      return;
    }
    const needs_leader_review = formData.needs_leader_review === "1";
    onConfirm?.({ comment, needs_leader_review });
    return;
  };

  return (
    <ModalComponent
      open={open}
      handleClose={handleCloseModal}
      title={"Confirmar finalización"}
      width={"600px"}
      actions={
        <div className="j-center w-complete">
          <LaddaButton
            width={"200px"}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            <div className="HContainer align-center">
              <p className="button_text">Completar</p>
            </div>
          </LaddaButton>
        </div>
      }
    >
      <form>
        <div style={{ marginTop: 8 }}>
          {task?.description && (
            <p className="detail-label" style={{ marginBottom: 8 }}>
              <strong>Tarea:</strong> {task.description}
            </p>
          )}

          <p className="detail-label mt-10">Comentario:</p>
          <FormTextField
            name="comment"
            control={control}
            isTextArea={true}
            error={errors.comment}
            maxLength={MAX_COMMENT_LENGTH}
            rows={5}
            margin={"0"}
            placeholder={`Agrega un comentario (máx. ${MAX_COMMENT_LENGTH})...`}
          />
          <p
            className="detail-helper"
            style={{ fontSize: 12, color: "#888", marginTop: 6 }}
          >
            Al confirmar, se marcará la tarea como completada y el comentario
            quedará registrado.
          </p>

          <p
            className="detail-label"
            style={{
              marginTop: 16,
              marginBottom: 8,
              color: "#1D4ED8",
              fontWeight: 600
            }}
          >
            ¿Requiere atención del líder de equipo?
          </p>
          <FormRadioButton
            name="needs_leader_review"
            control={control}
            options={[
              { label: "Sí", value: "1" },
              { label: "No", value: "0" }
            ]}
            error={errors.needs_leader_review}
          />
        </div>
      </form>
    </ModalComponent>
  );
};

export default CompleteTaskModal;
